export default function getIsAccessibleRecording(user, recording) {
  const isPatron = !!user && !!user.isPatron;
  const { isPremium } = recording;
  return !isPremium || (isPremium && isPatron);
}
